exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".org-status .form-group label {\n  font-weight: bold; }\n\n.org-status .modify-org-info {\n  text-decoration: underline;\n  margin-right: 20px;\n  font-weight: bold; }\n\n.org-status .loader {\n  margin-left: -20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/organization-status/organization-status.component.scss
// module id = ../../../../../src/app/authorized/organization-status/organization-status.component.scss
// module chunks = main